<mat-card class="component-card">
  <mat-card-title>
    <h1 class="pb-3">Daily Forecast</h1>
  </mat-card-title>

  @if (loading) {
    <mat-progress-bar class="mt-3" mode="query" />
  } @else {
    <mat-card-content>
      <div class="table-container">
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Date</th>
            <td mat-cell *matCellDef="let forecast">
              {{ forecast.date | date: 'EE d MMM y' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="weatherType">
            <th mat-header-cell *matHeaderCellDef>Weather</th>
            <td mat-cell *matCellDef="let forecast">
              <img
                class="weather-icon"
                [src]="'../../../../assets/weather/' + forecast.weatherType + '.svg'"
                [alt]="forecast.weatherType" />
            </td>
          </ng-container>

          <ng-container matColumnDef="temperature">
            <th mat-header-cell *matHeaderCellDef>Temperature</th>
            <td mat-cell *matCellDef="let forecast">
              <span [ngClass]="forecast.temperature.max < 0 ? 'negative-temp' : 'positive-temp'">
                {{ forecast.temperature.max | number: '1.0-0' }}°C
              </span>
              <span class="ms-1 me-1">/</span>
              <span [ngClass]="forecast.temperature.min < 0 ? 'negative-temp' : 'positive-temp'">
                {{ forecast.temperature.min | number: '1.0-0' }}°C
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="precipitation">
            <th mat-header-cell *matHeaderCellDef>Precipitation</th>
            <td mat-cell *matCellDef="let forecast">{{ forecast.precipitation }} mm</td>
          </ng-container>

          <ng-container matColumnDef="wind">
            <th mat-header-cell *matHeaderCellDef>Wind</th>
            <td mat-cell *matCellDef="let forecast">{{ forecast.wind.max }} m/s</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </mat-card-content>
  }
</mat-card>
